/**
 * External dependencies
 */
import styled from '@emotion/styled';
/**
 * Internal dependencies
 */
import { FlexBlock } from '../../flex';

export const SelectWrapper = styled( FlexBlock )`
	flex-grow: 5;
`;

export const AccessoryWrapper = styled( FlexBlock )`
	flex-grow: 4;
`;
